module.exports = __webpack_public_path__ + "assets/img/app.ac6e7fb0.png";